// react
import React from 'react';
import styled from 'styled-components';

/**
 * NavBarTemplate is a template for the NavBar component.
 */
export const NavBarTemplate = ({
  version,
  navBar,
  content,
  banner,
}: NavBarTemplateProps) => {
  return (
    <StyledNavBarTemplate>
      {version && <StyledNavBar>{version}</StyledNavBar>}
      {navBar && <StyledNavBar>{navBar}</StyledNavBar>}
      {banner && <StyledNavBar>{banner}</StyledNavBar>}
      <StyledContent>{content}</StyledContent>
    </StyledNavBarTemplate>
  );
};

const StyledNavBarTemplate = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const StyledNavBar = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  flex: 0 0 auto;
`;

const StyledContent = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
`;

interface NavBarTemplateProps {
  version?: React.ReactNode;
  navBar?: React.ReactNode;
  banner?: React.ReactNode;
  content: React.ReactNode;
}

NavBarTemplate.displayName = 'NavBarTemplate';

export default NavBarTemplate;
